import {
  TraceKeyCondition,
  TraceKeyResponseTypeEnum,
} from '@ulysses-inc/harami_api_client'

const validFilterValuesOf = {
  deviatedAnswer: ['present', 'absent'] as const,
  status: [
    'inCompleted',
    'approvalPending',
    'approvalRemand',
    'completed',
  ] as const,
}

type DeviatedAnswerFilterValue =
  (typeof validFilterValuesOf.deviatedAnswer)[number]
type StatusFilterValue = (typeof validFilterValuesOf.status)[number]

export const isValidFilterValueOf = {
  deviatedAnswer: (testee: unknown): testee is DeviatedAnswerFilterValue => {
    return validFilterValuesOf.deviatedAnswer.some(v => v === testee)
  },
  status: (testee: unknown): testee is StatusFilterValue => {
    return validFilterValuesOf.status.some(v => v === testee)
  },
}

/**
 * TypeScript の Union Type を使って、TraceKeyCondition の responseType に応じて異なるフィールドを持つオブジェクトを定義する
 */
export type UnionTraceKeyCondition = {
  traceKeyId: TraceKeyCondition['traceKeyId']
} & (
  | {
      responseType: TraceKeyResponseTypeEnum.ResponseSet
      responseSet: NonNullable<TraceKeyCondition['responseSet']>
    }
  | {
      responseType: TraceKeyResponseTypeEnum.Date
      datetime: TraceKeyCondition['datetime']
    }
  | {
      responseType: TraceKeyResponseTypeEnum.Text
      text: NonNullable<TraceKeyCondition['text']>
    }
)

/**
 * レポート一覧を取得するにあたってAPIに指定できる絞り込み条件
 */
export type ReportListFilters = {
  dateFrom: string | null
  dateTo: string | null
  deviatedAnswer: DeviatedAnswerFilterValue[]
  employeeNameOrCode: string
  page: number
  pageSize: number
  placeNodeUuids: string[]
  reportName: string
  statuses: StatusFilterValue[]
  traceKeyConditions: UnionTraceKeyCondition[]
}
